module.exports = __webpack_public_path__ + "img/fjellskred.5417685f.jpg";